import React, { useState, useEffect, useRef, useMemo } from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@mui/styles";
import TextField from "@mui/material/TextField";
import Autocomplete, {
  createFilterOptions,
} from "@mui/material/Autocomplete";
import Chip from '@mui/material/Chip';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: '#fff',
    display: "flex",
  },
  tabs: {
    borderRight: `1px solid rgba(0, 0, 0, 0.12)`,
  },
  tab: {
    paddingLeft: "0rem",
    marginLeft: "0rem",
    flexDirection: "column",
    textAlign: "left",
    display: "grid",
    justifyContent: "left",
    alignItems: "flex-start",
    maxWidth: "3rem",
  },
  input: {
    display: "flex",
    flexDirection: "column",
    margin: "1rem 0rem 1.3rem",
  },
  inputTitle: {
    margin: "0.2rem 0rem 0.05rem 0.5rem",
    color: "#000000",
  },
  select: {
    display: "flex",
    flexDirection: "column",
    margin: "1rem 0.5rem",
  },
  switch: {
    marginLeft: "0.5rem",
  },
  textField: {
    fontSize: "14px",
    fontFamily: '"Source Sans Pro",sans-serif',
    "& .MuiInputBase-root": {
      height: "45px",
    },
    "& .MuiInputBase-input": {
      fontSize: "14px",
      fontFamily: '"Source Sans Pro",sans-serif',
    },
    "& .MuiInputLabel-outlined": {
      fontSize: "14px",
      fontFamily: '"Source Sans Pro",sans-serif',
      transform: "translate(14px, 13px) scale(1)",
      color: "rgba(0, 0, 0, 0.54) !important",
    },
    "& .MuiInputLabel-outlined.MuiInputLabel-shrink" : {
      transform: "translate(14px, -6px) scale(0.75)",
      color: "rgba(0, 0, 0, 0.54) !important",
    },
    "& .MuiAutocomplete-tag": {
      fontSize: "12px",
      fontFamily: '"Source Sans Pro",sans-serif',
      height: "24px",
    },
    '& .Mui-disabled' : {
      color: "#000000",
      opacity: "1",
    },
    '& .MuiOutlinedInput-root': {
      '&:hover fieldset': {
        borderColor: '#605f70',
      },
      '&.Mui-focused fieldset': {
        borderColor: '#605f70',
      },
    },
  },
  chipstyledisabled:{
    '& .MuiChip-deleteIcon	': {
      display: "none", 
    },
    color : "#000000 !important",
    fontSize: "12px !important",
    fontFamily: '"Source Sans Pro",sans-serif !important',
    height: "24px !important",
    cursor: "pointer !important",
    marginRight: "6px !important",
    opacity: "1",
  }
  ,
  chipstyle:{
    color : "#000000",
    fontSize: "12px !important",
    fontFamily: '"Source Sans Pro",sans-serif !important',
    height: "24px !important",
    cursor: "pointer",
    marginRight: "6px !important",
    opacity: "1 !important",
  },
  chipdiv:{
    borderRadius: "4px",
    border: "1px solid #bdbdbd",
    height: "45px",
    paddingTop: "10px",
    margin: "2px 8px",
  },
  nofilediv:{
    paddingLeft: "13px",
    color: "#000000",
    paddingTop: "1px",
    fontSize: "14px",
      fontFamily: '"Source Sans Pro",sans-serif',
  }
}));

export default function AutocompleteTagsInput(props) {
  const { inputTitle, selected, list, handleChange, specialWidth, isRequired, isMultiple } = props;

  const classes = useStyles();
// console.log(list);
  return (
    <div className={classes.input}>
      {/* <text className={classes.inputTitle}>{inputTitle}</text> */}
      <Autocomplete
            multiple
            disabled={props.disabled}
            id="tags-filled"
            style={{ width: specialWidth }}
            // options={list.map((option) => option)}
            options={list}
            value={selected}
            freeSolo
            // ChipProps={props.disabled ? {className:classes.chipstyledisabled} : {className:classes.chipstyle}}
            renderTags={(value, getTagProps) =>
              
              value.map((option, index) => (
                <Chip variant="outlined" label={option} {...getTagProps({ index })} className={props.disabled ? classes.chipstyledisabled : classes.chipstyle} />
              ))
            }


            renderInput={(params) => (
              <TextField
            {...params}
              required = {isRequired}
              style={{ margin: "2px 8px" }}
              variant="outlined"
              label={inputTitle}
              placeholder={props.disabled ? "" : "Ajouter"}
              className={classes.textField}
              
            />
            )}
            onChange={(_, newValue) =>
              {
                handleChange(newValue);
              }
            }
          />
    </div>
  );
}

AutocompleteTagsInput.defaultProps = {
  specialWidth: "99%",
  isRequired: false,
  isMultiple: true,
};

AutocompleteTagsInput.propTypes = {
  isMultiple: PropTypes.bool,
  isRequired: PropTypes.bool,
  specialWidth: PropTypes.string,
  inputTitle: PropTypes.any,
  dateInput: PropTypes.any,
  handleChange: PropTypes.any,
};
